<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="update()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Editar Parceria</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3">
                    
                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Nome *" 
                            type="text" 
                            placeHolder="Digite aqui o nome da Parceria ..."
                            v-model="parceriaEdit.nome"
                            />
                        </div>

                    </div>

                    <div class="mb-0 d-flex gap-2" >

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Percentual de desconto *" 
                            type="number" 
                            placeHolder="Digite aqui o percentual de desconto *"
                            v-model="parceriaEdit.percentual_desconto"
                            min="0"
                            max="100"
                            step="0.01"
                            />
                        </div>

                    </div>

                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Salvar" type="success" :submit="true" :isLoading="isLoading" :loadingText="'Atualizando Parceria'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
    import { useParceriasStore } from '@/stores/parcerias';
    import { toast } from 'vue3-toastify'

    export default{
        props:{
            isVisible : {
                type : Boolean,
                default: false
            },
            parceria: {
                type: Object
            }
        },
        emits:['close'],
        data(){
            return{
                parceriasStore : useParceriasStore(),
                isLoading: false,
                parceriaEdit: {}
            }
        },
        methods:{
            closeModal(){
                this.$emit('close');
            },
            async update(){

                this.isLoading = true
                const result = await this.parceriasStore.update(this.parceriaEdit)
                this.isLoading = false

                if(result.status){
                    toast.success("Parceria atualizada com sucesso")
                    this.closeModal()
                    this.parceriasStore.get()
                }else{
                    toast.error(result.message)
                }

            }
        },
        watch:{
            'parceria' : {
                handler(parceriaNew){
                    this.parceriaEdit = { ...parceriaNew }
                },
                immediate: true
            }
        }
    }
</script>